import React from 'react';
import { Flex, Heading, Button } from 'rebass';
import Field from 'components/Field';

interface JobRequirementsStepProps {
  handleSubmit: void;
  hasValidationErrors: boolean;
  setNextFormStepHandler: any;
  setPreviousFormStepHandler: any;
}

const JobRequirementsStep: React.FC<JobRequirementsStepProps> = (props): JSX.Element => {
  const {
    handleSubmit,
    hasValidationErrors,
    setNextFormStepHandler,
    setPreviousFormStepHandler,
  } = props;

  return (
    <Flex flexDirection="column" alignItems="center" py={7}>
      <Heading fontSize={['20px']} fontWeight={6} mb={5}>
        What are the requirements for this position?
      </Heading>
      <Field name="requirements" placeholder="List your requirements here." inputType="textarea" />
      <Heading fontSize={['20px']} fontWeight={6} mb={2}>
        What are the job responsibilities?
      </Heading>
      <Field
        name="responsibilities"
        placeholder="List your responsibilities here."
        inputType="textarea"
      />
      <Flex width="100%" justifyContent="space-between" mt={2} css="max-width: 550px;">
        <Button variant="primary" onClick={setPreviousFormStepHandler}>
          Back
        </Button>
        <Button
          variant="primary"
          onClick={hasValidationErrors ? handleSubmit : setNextFormStepHandler}
        >
          Next
        </Button>
      </Flex>
    </Flex>
  );
};

export default JobRequirementsStep;
